<!--
 * @Author: fengqianhui
 * @Date: 2024-01-10 12:07:17
 * @LastEditors: fengqianhui fengqianhui@wedobest.com.cn
 * @LastEditTime: 2024-04-12 15:29:57
 * @FilePath: \landingpage\src\views\build\components\FunctionArea.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<script setup lang="ts">
import { ref } from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';
import TableView from './TableView.vue';
import SelfTest from './SelfTest.vue';
import { useOriginDataStore } from '@/stores/originDataStore';
const store = useOriginDataStore();
const originData = computed(() => store.data);
const switchValue = ref(0);
</script>

<template>
  <div class="left-box">
    <div class="package-box" v-if="switchValue" v-html="originData?.packageInfo.replace(/\n/g, '<br>')"></div>
    <div class="function-box" v-else>
      <div class="inner-title">
        <SvgIcon iconClass="tab"></SvgIcon>
        版本说明
      </div>
      <div class="info-area">{{ originData?.projectDesc ? originData.projectDesc : '暂无说明' }}</div>
      <div class="inner-title">
        <SvgIcon iconClass="tab"></SvgIcon>
        功能清单
      </div>
      <TableView></TableView>

      <SelfTest></SelfTest>
    </div>
    <div v-show="originData?.packageType != 1" class="warning">
      <SvgIcon iconClass="warning"></SvgIcon>
      沙盒测试参数用于快速对接，实现功能。上线前，需要替换成正式参数。
    </div>
  </div>
</template>

<style scoped lang="less">
.left-box {
  height: 100%;
  border-radius: 2px;
  box-sizing: border-box;
  background: rgba(248, 249, 250, 1);
  padding: 16px 24px;
  overflow-y: auto;
  overflow-x: auto;
  .package-box {
    margin-top: 16px;
    color: rgba(0, 0, 0, 0.85);
    font-family: AlibabaPuHuiTi2.0-55Regular;
    font-size: 14px;
    word-wrap: break-word;
  }
  .function-box {
    margin-top: 16px;
    .inner-title {
      color: rgba(0, 0, 0, 0.85);
      font-family: AlibabaPuHuiTi2.0-85Bold;
      font-size: 16px;
      margin-bottom: 16px;
      font-weight: bold;
    }
    .info-area {
      color: rgba(0, 0, 0, 1);
      font-family: AlibabaPuHuiTi2.0-55Regular;
      font-size: 13px;
      padding: 15px;
      min-height: 80px;
      border-radius: 2px;
      border: 1px solid rgba(219, 224, 237, 1);
      background: rgba(255, 255, 255, 1);
      line-height: 20px;
      margin-bottom: 24px;
    }
  }
  .warning {
    font-weight: bold;
    margin-top: 20px;
    font-size: 15px;
  }
}
</style>
<style scoped lang="less">
@media (max-width: 550px) {
  .mobile-viewport .left-box {
    margin: 0 12px;
    border-radius: 2px;
    padding: 16px 12px;
  }
  .mobile-viewport .ant-radio-group {
    width: 70% !important;
  }
}
</style>
